import * as React from "react";
import { JSX } from "react";

/**
 * Renders a skeleton IconToggle
 * @param props
 */
function IconToggle(props: { children?: React.ReactNode, className?: string, text?: string}): JSX.Element {
  return (
    <label className={`icon-toggle${props.className ? ` ${props.className}` : ""}`}>
      <span className="bone">
        <i className="fa fa-toggle-off" />{props.text}{props.children}
      </span>
    </label>
  );
}

export { IconToggle };
